import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgPencilIconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.709 5.631c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 011.41 0l2.34 2.34zm-17.71 14.87v-3.04c0-.14.05-.26.15-.36l10.91-10.91 3.75 3.75-10.92 10.91a.47.47 0 01-.35.15h-3.04c-.28 0-.5-.22-.5-.5z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgPencilIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.487 1.513a1.75 1.75 0 00-2.474 0L1.22 11.306a.75.75 0 00-.22.53v2.5c0 .414.336.75.75.75h2.5a.75.75 0 00.53-.22l9.793-9.793a1.75 1.75 0 000-2.475l-1.086-1.085zm-1.414 1.06a.25.25 0 01.354 0l1.086 1.086a.25.25 0 010 .354L12 5.525l-1.44-1.44 1.513-1.512zM9.5 5.146l-7 7v1.44h1.44l7-7-1.44-1.44z"
        fill="currentColor"
      />
    </svg>
  );
}

function PencilIcon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgPencilIconV2 : SvgPencilIconV1;
  return <Icon {...props} component={component} />;
}

export default PencilIcon;
